import textStyles from 'config/branding/textStyles';
import Link from '@activebrands/core-web/components/Link';
import RichText from '@activebrands/core-web/libs/storyblok/RichText';
import { InfoBox } from '@activebrands/core-web/libs/storyblok/storyblok';
import { styled } from '@activebrands/core-web/libs/styletron';
import ThemeButton from 'components/buttons/ThemeButton';
import Heading from 'components/text/Heading';

interface InfoBoxesProps {
    $style?: any;
    boxes: Array<InfoBox>;
}

const Wrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
});

const InnerWrapper = styled('div', {
    padding: '16px',
    backgroundColor: 'var(--color-bg-checkout-info-boxes)',
    border: '2px solid var(--color-border-checkout-info-boxes)',
});

const RichTextWrapper = styled('div', {
    marginTop: '8px',
    ...textStyles['Secondary/14_130_-0175'],
});

const InfoBoxes = ({ $style = {}, boxes = [] }: InfoBoxesProps) => (
    <Wrapper $style={$style}>
        {boxes.map(({ heading, paragraph, button, show }) => (
            <InnerWrapper $style={{ display: show ? 'block' : 'none' }} key={heading}>
                {heading && <Heading fontKeys="Secondary/18_120_-0225">{heading}</Heading>}
                {paragraph && (
                    <RichTextWrapper>
                        <RichText data={paragraph} />
                    </RichTextWrapper>
                )}
                {button && (
                    <ThemeButton
                        $style={{ marginTop: '8px' }}
                        as={Link}
                        fontKeys="Miscellaneous/14_100"
                        theme={button.theme}
                        to={button.url}
                        rel={button.rel}
                    >
                        {button.label}
                    </ThemeButton>
                )}
            </InnerWrapper>
        ))}
    </Wrapper>
);

export default InfoBoxes;
